module.exports = __webpack_public_path__ + "img/download.eb1d2fb7.svg";